import React from 'react'
import styled from '@emotion/styled'

import { BlockBDCNavy } from '@jelly/components'

const StyledHeader = styled.header`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.white};
	display: flex;
	height: auto;
	padding: 2rem 1.25rem 1rem;
	width: 100%;
`
const LogoContainer = styled.div`
	height: auto;
	margin-right: 2rem;
	width: 188px;

	${({ theme }) => theme.MQ.M} {
		max-width: 250px;
		width: auto;
	}
`
const Tagline = styled.div`
	display: none;

	${({ theme }) => theme.MQ.M} {
		${({ theme }) => theme.fonts.primary};
		color: ${({ theme }) => theme.colors.gray[500]};
		display: flex;
		font-size: 1.125rem;
		letter-spacing: 1px;
		line-height: 27px;
		margin-top: -12px;
		text-transform: uppercase;
	}
`

/**
 * Header for Leave Behind Page
 */
function Header() {
	return (
		<StyledHeader>
			<LogoContainer>
				<BlockBDCNavy />
			</LogoContainer>
			<Tagline>Smart Business Purchases Delivered.</Tagline>
		</StyledHeader>
	)
}

export default Header
